<template>
  <div class="Popup-info">
    <div class="Center">
      <div class="Notice-icon">
        <img
          :src="formattedMessage.imageUrl"
          width="80"
        >
      </div>
      <p class="acc-item Notice-subHead">
        {{ formattedMessage.subTitle }}
      </p>
      <h2 class="acc-item  Notice-header">
        <strong>{{ formattedMessage.title }}
          <span v-if="formattedMessage.type !== 'companies'">
            at  {{ formattedMessage.companyName }}
          </span></strong>
      </h2>
      <p>{{ formattedMessage.message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    savedItemInfo: {
      type: Object,
      default: null,
    },
  },

  computed: {
    formattedMessage() {
      if (this.savedItemInfo) {
        if (this.savedItemInfo.type === 'companies') {
          return {
            title: this.savedItemInfo.title,
            type: this.savedItemInfo.type,
            companyName: this.savedItemInfo.companyName,
            subTitle: 'You tried to save',
            message: `Please log in or sign up for free to add this company to your saved items.
                        You'll be the first to hear about new job opportunities and upcoming deadlines.`,
            imageUrl: `${RMP_CDN_URL}/website/shortlisting/thumb.svg`,
          };
        }
        if (this.savedItemInfo.type === 'reviews') {
          return {
            title: this.savedItemInfo.title,
            type: this.savedItemInfo.type,
            companyName: this.savedItemInfo.companyName,
            subTitle: 'You tried to save',
            message: 'Please log in or sign up for free to add this review to your saved items.',
            imageUrl: `${RMP_CDN_URL}/website/shortlisting/star.svg`,
          };
        }
        if (this.savedItemInfo.type === 'jobs') {
          return {
            title: this.savedItemInfo.title,
            type: this.savedItemInfo.type,
            companyName: this.savedItemInfo.companyName,
            subTitle: 'You tried to save',
            message: `Please log in or sign up for free to add this job to your saved items.
                        Don’t worry, we will let you know when the deadline is about to close.`,
            imageUrl: `${RMP_CDN_URL}/website/shortlisting/heart.svg`,
          };
        }
      }

      return {
        title: '',
        type: '',
        company: '',
        subTitle: '',
        message: '',
        imageUrl: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  svg {
    position: absolute;
    top: 0;
    left: 0;
    &.svg{
      animation: scaleOut 1.5s infinite ease-in-out;
    }
    &.pulse-one {
      animation: pulse-me 3s infinite ease-in-out;
    }

    &.pulse-two {
      animation: pulse-me 3s infinite  ease-in-out;
      animation-delay: 1.5s;
    }
  }

  .SvgIconBox {
    position: relative;
    width: 87px;
    height: 77px;
    margin: 2rem;
  }

  @keyframes pulse-me {
    0% {
      transform: scale(0.6);
      opacity: 0;
    }
    50% {
      opacity: 0.8;
    }
    70% {
      opacity: 0.5;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }

  @keyframes scaleOut {
    0% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }

</style>
